import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Http from '@/services/Http';
import Auth from '@/services/Auth';
import cssVars from 'css-vars-ponyfill';
import Qdebug from '@/mixins/Qdebug';
export default (/*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var app, store, Vue, client, common, user, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          app = _ref.app, store = _ref.store, Vue = _ref.Vue;
          Vue.mixin(Qdebug);
          client = Http.client();
          _context.next = 1;
          return client.get('/common');
        case 1:
          common = _context.sent;
          store.dispatch('common/setCommonData', common.data);
          // user data
          _context.prev = 2;
          _context.next = 3;
          return client.get('/auth/check');
        case 3:
          user = _context.sent;
          store.dispatch('user/setUserData', user.data);
          sessionStorage.setItem('users', JSON.stringify(user.data.users));
          Auth.login();
          _context.next = 5;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](2);
          Auth.logout();
        case 5:
          // set variables
          cssVars({
            variables: {
              '--q-color-primary': common.data.branding.branding_primary_color,
              '--q-color-secondary': common.data.branding.branding_secondary_color,
              '--q-color-positive': common.data.branding.branding_positive_color,
              '--q-color-negative': common.data.branding.branding_negative_color,
              '--q-color-accent': common.data.branding.branding_accent_color,
              '--q-color-info': common.data.branding.branding_info_color,
              '--q-color-warning': common.data.branding.branding_warning_color
            },
            rootElement: document
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 4]]);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());